import { render } from "./SetAliceConfig.vue?vue&type=template&id=69397842"
import script from "./SetAliceConfig.vue?vue&type=script&lang=js"
export * from "./SetAliceConfig.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__